export default __webpack_public_path__ + "static/media/icon-01.21a974ab.svg";